export enum ECardTypes {
  Visa = 'Visa',
  MasterCard = 'MasterCard',
  Maestro = 'Maestro',
  Other = 'Other',
}
